// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__11CB2","alert":"SettungsInbox_alert__1vPw3"};